import { schemaDonationRequest } from "reusable/Form/FormSchema"
import * as yup from "yup"

export interface IFormInput {
  IsDonationPolicy: boolean | null | string

  PartAFromNonProfitOrganization: boolean | null
  PartANotMarketingPromotion: boolean | null
  PartASubject: string
  PartAAssociationDetailsName: string
  PartAAssociationDetailsNumber: string
  PartAAssociationDetailsPhone: string
  PartAAssociationDetailsWebsite: string
  PartAAssociationDetailsCeo: string
  PartAAmount: number | null
  PartAVolunteeringOptions: string
  PartAContactUsDetailsName: string
  PartAContactUsDetailsContactRole: string
  PartAContactUsDetailsPhone: string
  PartAContactUsDetailsEmail: string
  PartAActivityAndGoals: string
  PartAIsAshtromGroupConnection: boolean | null
  PartAAshtromGroupConnection: string

  PartBDescription: string
  PartBProjectGoals: string
  PartBTargetAudienceName: string
  PartBTargetAudienceSupportingPeopleAmount: string
  PartBArea: string
  PartBProjectSchedule: string
  PartBChangesToAchieve: string
  PartBProjectSuccessYourOpinion: string
}

export const schema = yup.object({
  IsDonationPolicy: schemaDonationRequest.booleanValue,
  PartAFromNonProfitOrganization: schemaDonationRequest.booleanValue,
  PartANotMarketingPromotion: schemaDonationRequest.booleanValue,
  PartASubject: schemaDonationRequest.stringValue,
  PartAAssociationDetailsName: schemaDonationRequest.stringValue,
  PartAAssociationDetailsNumber: schemaDonationRequest.registeredNumber,
  PartAAssociationDetailsPhone: schemaDonationRequest.allPhoneNumber,
  PartAAssociationDetailsWebsite: schemaDonationRequest.urlValue,
  PartAAssociationDetailsCeo: schemaDonationRequest.stringValue,
  PartAAmount: schemaDonationRequest.donationAmountValue,
  PartAVolunteeringOptions: schemaDonationRequest.stringValueTextarea,
  PartAContactUsDetailsName: schemaDonationRequest.stringValue,
  PartAContactUsDetailsContactRole: schemaDonationRequest.stringValue,
  PartAContactUsDetailsPhone: schemaDonationRequest.allPhoneNumber,
  PartAContactUsDetailsEmail: schemaDonationRequest.email,
  PartAActivityAndGoals: schemaDonationRequest.stringValueTextarea,
  PartAIsAshtromGroupConnection: schemaDonationRequest.booleanValue,
  PartAAshtromGroupConnection: schemaDonationRequest.stringValueTextarea,
  PartBDescription: schemaDonationRequest.stringValueTextarea,
  PartBProjectGoals: schemaDonationRequest.stringValueTextarea,
  PartBTargetAudienceName: schemaDonationRequest.stringValue,
  PartBTargetAudienceSupportingPeopleAmount:
    schemaDonationRequest.amountOfPeople,
  PartBArea: schemaDonationRequest.stringValue,
  PartBProjectSchedule: schemaDonationRequest.stringValue,
  PartBChangesToAchieve: schemaDonationRequest.stringValueTextarea,
  PartBProjectSuccessYourOpinion: schemaDonationRequest.stringValueTextarea,
})
